/**
 * This file created by jiao on 11/21/18.
 * Copyright 2018-present, Alpstein Software x ls-square-app.
 * All rights reserved.
 */

export const getFavouriteFoodListData = state =>
  state && state.list && state.list.items ? state.list.items : [];
export const getFavouriteFoodListPagination = state =>
  state && state.list && state.list.pagination ? state.list.pagination : null;
export const getFavouriteFoodListLoading = state =>
  state && state.list && state.list.loading ? state.list.loading : false;
export const getFavouriteFoodListHideLoading = state =>
  state ? state.hideLoading : false;



// WEBPACK FOOTER //
// ./src/selectors/favourite.js